import { CACHE_KEYS } from "@/common/constants"
import { api } from "@/configs/axios"

type LoginInput = {
  username: string
  email: string
  phoneNumber: string
  cpf: string
}

export type SingleUser = {
  id: string
  username: string
  email: string
  phoneNumber: string
  cpf: string
  wallet: {
    amount: number
  }
}

type LoginOutput = {
  user: SingleUser
  accessToken: string
}

type GetWalletResponse = {
  id: string
  userId: string
  amount: number
}

export class UserService {

  async login(input: LoginInput) {
    const { data } = await api.post<LoginOutput>("/auth/signin", input)
    localStorage.setItem(CACHE_KEYS.TOKEN, data.accessToken)
    return data.user
  }

  async wallet() {
    const { data } = await api.get<GetWalletResponse>("/wallets/me")
    return data.amount
  }

  async me() {
    try {
      const { data } = await api.get<SingleUser>("/users/me")
      return data
    } catch (e) {
      console.error(e)
      return undefined
    }
  }
}

export const userServiceInstance = new UserService()